<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="title">身份证</div>
      <el-button type="primary" @click="websopen">打开身份证</el-button>
      <el-button type="primary" @click="closeIdcard">关闭身份证</el-button>
      <div>
        <div>身份证信息</div>
        {{ idCardInfo }}
      </div>
      <div>
        <div class="title">条码扫描</div>
        <el-input v-model="code" placeholder="请输入内容"></el-input>
      </div>
      <div>
        <div class="title">高拍仪</div>
        <!-- <div class="gpy-box"> -->
        <el-button class="btn-box" type="primary" @click="gpyRotate(270)">开启高拍仪</el-button>
        <div>
          <img class="gpy-images" src="http://127.0.0.1:38088/video=stream&camidx=0?1" alt="">
          <el-button class="btn-box" type="primary" @click="getImage">拍照</el-button>
        </div>
        <div class="file-box">
          <img class="print-img" :src="item" v-for="(item, idx) in gpyimg" :key="idx">
        </div>
        <!-- </div> -->
      </div>
      <div>
        <div class="title">LODOP</div>
        <el-button type="primary" @click="printPDF">打印PDF</el-button>
        <el-button type="primary" @click="printIMG">打印IMG</el-button>
      </div>
    </div>
    <Back />
  </div>
</template>
<script>
import lodop from "@/assets/js/doPrint.js"

export default {
  name: '',
  data() {
    return {
      //
      webSkt: null,
      wsUri: "ws://127.0.0.1:24012",//刷身份证ws
      idCardInfo: '未启用',
      code: '',
      gpyimg: []
    };
  },
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {
    //
    printPDF() {
      console.log('打印PDF');
      lodop.pdfPrint("http://10.80.17.8:8081/prod-api/profile/upload/2024/11/22/830bb6a5-6eec-4b11-aa4c-322bf8922212.pdf")
    },

    printIMG() {
      console.log('打印图片');
      lodop.zzPrint("http://10.80.17.8:8081/prod-api/profile/upload/2024/05/14/c5e26a99-fcbc-4c9a-81d0-bbee1b45bbe3.jpg")
    },
    websopen() {
      this.webSkt = new WebSocket(this.wsUri);
      this.webSkt.onopen = (evt) => {
        // console.log('身份证就绪', evt);
        this.doSend("{\"module\":\"idcard\",\"msgid\":\"123456789\",\"function\":\"autoreadcard\",\"parameter\":{\"dev\":\"1\",\"repeat\":\"1\",\"readtype\":\"1\"}}");
      };
      this.webSkt.onmessage = (evt) => {
        this.onMessage(evt)
      };
      this.webSkt.onerror = (evt) => {
        console.log('身份证错误', evt);
      };
    },
    onMessage(evt) {
      var jsondata = JSON.parse(evt.data);
      console.log('返回信息', jsondata);
      if (jsondata.event == 'onreadcard') {
        var data = jsondata.Certificate
        this.idCardInfo = JSON.stringify(data)
      } else {
        this.idCardInfo = '已开启身份证读取'
      }
    },
    doSend(message) {
      this.webSkt.send(message);
    },
    closeIdcard() {
      this.webSkt.close();
      this.idCardInfo = '已关闭身份证读取'
    },
    getImage() {
      let data = {
        "filepath": "base64",
        "rotate": "0",
        "cutpage": "0",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      this.$rqt.video_grabimage(JSON.stringify(data)).then(res => {
        this.gpyimg.push("data:image/jpg;base64," + res.photoBase64)
      })
    },
    gpyRotate(angle) {
      let data = { "camidx": '0', "rotate": String(angle) }
      this.$rqt.video_rotate(JSON.stringify(data))
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.title {
  font-size: 5rem;
  margin-bottom: 10px;
}

.gpy-box {
  display: flex;
}

.gpy-images {
  width: 70%;
}
</style>